export const COUPONS_GET_SUCCESS = 'COUPONS_GET_SUCCESS';
export const COUPONS_SET_CACHE_READY = 'COUPONS_SET_CACHE_READY';
export const COUPONS_LOADED = 'COUPONS_LOADED';
